import axios from 'axios';
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
const BASE_URL = process.env.VUE_APP_ADMIN_URL;

const PUSHER_APP_ID = process.env.VUE_APP_PUSHER_APP_ID;
const PUSHER_APP_KEY = process.env.VUE_APP_PUSHER_APP_KEY;
const PUSHER_APP_SECRET = process.env.VUE_APP_PUSHER_APP_SECRET;
const PUSHER_APP_CLUSTER = process.env.VUE_APP_PUSHER_APP_CLUSTER;

export default {
    axios: axios,
    LS_TOKEN_KEY_NAME: 'token',
    LS_PERMISSION_KEY_NAME: 'user_permissions',
    LS_USER_KEY_NAME: 'user',
    ADMIN_URL: ADMIN_URL,
    BASE_URL: BASE_URL,

    permissionsList: {
        manage_roles: ['manage roles'] ,
        tournament: ['tournament create', 'tournament read','tournament update','tournament delete'],
        category: ['category create', 'category read', 'category update', 'category delete',],
        question: ['question create', 'question read', 'question update', 'question delete',],
        topic: ['topic create', 'topic read', 'topic update', 'topic delete',],
        partner: ['partner create', 'partner read', 'partner update', 'partner delete',],
        notification: ['notification create', 'notification read', 'notification update', 'notification delete',],
        question_approve : ['question approve'],
        dash_board : ['dashboard']

    },
    SECRET_KEY: 'Kali Nagin Ke Jaisi Julfe Teri Kali Kali',
    SECRET_KEY_SAME_AS_PARTNER_PANEL: 'Dust in the wind.', /* TO_EDIT_THIS_PLACE, This has to be same as Partner panel gbvar SECRET_KEY*/
    PUSHER_CREDENTIALS: {
        APP_ID: PUSHER_APP_ID,
        APP_KEY: PUSHER_APP_KEY,
        APP_SECRET: PUSHER_APP_SECRET,
        APP_CLUSTER: PUSHER_APP_CLUSTER
    }

}
